(function (root, factory) {
  var api = factory(root);
  root.HWCCampaignPDP = api;
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var CONFIG = {
    path: '/products/colombia',
    purchase: 'onetime',
    allowedVariants: ['41846116352048', '41846116450352'],
    leadVariant: '41846116352048',
    variantLabels: {
      '41846116352048': '2 lb whole bean',
      '41846116450352': '2 lb ground'
    },
    campaignParams: ['purchase', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'hwc_qa']
  };

  function toSearchParams(search) {
    try {
      return new URLSearchParams(search || '');
    } catch (e) {
      return new URLSearchParams('');
    }
  }

  function getCampaignState(locationLike, config) {
    var cfg = config || CONFIG;
    var loc = locationLike || {};
    var params = toSearchParams(loc.search || '');
    var variant = params.get('variant') || '';
    var purchase = params.get('purchase') || '';
    var pathOk = (loc.pathname || '') === cfg.path;
    var purchaseOk = purchase === cfg.purchase;
    var variantOk = cfg.allowedVariants.indexOf(variant) !== -1;
    var qaOnly = params.get('hwc_qa') === '1' && params.size === 1;

    return {
      valid: Boolean(pathOk && purchaseOk && variantOk && !qaOnly),
      pathOk: pathOk,
      purchaseOk: purchaseOk,
      variantOk: variantOk,
      variantId: variant,
      purchase: purchase,
      label: cfg.variantLabels[variant] || '',
      qaOnly: qaOnly
    };
  }

  function preserveCampaignParams(targetHref, currentSearch, config) {
    var cfg = config || CONFIG;
    var base = root.location && root.location.origin ? root.location.origin : 'https://hiswordcoffee.com';
    var url;
    try {
      url = new URL(targetHref, base);
    } catch (e) {
      return targetHref;
    }
    var current = toSearchParams(currentSearch || '');
    cfg.campaignParams.forEach(function (name) {
      if (!url.searchParams.has(name) && current.has(name)) {
        url.searchParams.set(name, current.get(name));
      }
    });
    if (url.origin === base) {
      return url.pathname + url.search + url.hash;
    }
    return url.toString();
  }

  function isValidCampaignMode() {
    if (!root.location) return false;
    return getCampaignState(root.location).valid;
  }

  function formSellingPlanControls(formId) {
    if (!root.document) return [];
    var selectors = [];
    if (formId) {
      selectors.push('input[name="selling_plan"][form="' + formId + '"]');
      selectors.push('select[name="selling_plan"][form="' + formId + '"]');
      selectors.push('#' + formId + ' input[name="selling_plan"]');
      selectors.push('#' + formId + ' select[name="selling_plan"]');
    }
    selectors.push('input[name="selling_plan"]');
    selectors.push('select[name="selling_plan"]');
    return Array.prototype.slice.call(root.document.querySelectorAll(selectors.join(',')));
  }

  function clearSellingPlan(formId) {
    formSellingPlanControls(formId).forEach(function (control) {
      control.value = '';
      control.disabled = true;
      control.setAttribute('data-hwc-campaign-disabled-selling-plan', 'true');
    });
  }

  function clickOneTimeOption(container) {
    if (!container) return false;
    var candidates = Array.prototype.slice.call(container.querySelectorAll('input[data-type="one_time"], input[value="onetime"], input[value="one_time"]'));
    var input = candidates.find(function (candidate) {
      return candidate.type === 'radio' || candidate.type === 'checkbox';
    });
    if (input) {
      if (!input.checked) {
        input.click();
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    var option = Array.prototype.slice.call(container.querySelectorAll('.sls-option-container, label, button')).find(function (node) {
      return /one[-\s]?time|single/i.test(node.textContent || '');
    });
    if (option) {
      option.click();
      return true;
    }
    return false;
  }

  function setButtonText(formId, text) {
    if (!root.document) return;
    var form = root.document.getElementById(formId);
    if (!form) return;
    var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], [name="add"]'));
    buttons.forEach(function (button) {
      button.setAttribute('data-hwc-campaign-cta', 'true');
      var node = Array.prototype.slice.call(button.childNodes).find(function (child) {
        return child.nodeType === 3 && child.textContent.trim();
      });
      if (node) {
        node.textContent = text;
      } else {
        button.textContent = text;
      }
    });
  }

  function setCampaignDisplayPrice(documentLike) {
    var doc = documentLike || root.document;
    if (!doc) return false;
    var priceContainer = doc.querySelector('.product-info__price');
    if (!priceContainer) return false;
    var priceList = priceContainer.querySelector('price-list.price-list--lg') || priceContainer.querySelector('price-list');
    if (!priceList) return false;
    var money = priceList.querySelector('.money') || priceList.querySelector('sale-price');
    if (!money) return false;
    if (!money.getAttribute('data-hwc-original-price')) {
      money.setAttribute('data-hwc-original-price', (money.textContent || '').trim());
    }
    money.textContent = '$45.00';
    money.setAttribute('data-hwc-campaign-display-price', '45.00');
    return true;
  }

  function updateCampaignCopy(state) {
    if (!root.document) return;
    var campaign = root.document.querySelector('.hwc-campaign-pdp[data-hwc-campaign-pdp]');
    if (!campaign) return;
    campaign.setAttribute('data-hwc-purchase-mode', 'onetime');
    campaign.setAttribute('data-hwc-selected-variant', state.variantId);
    var grind = campaign.querySelector('[data-hwc-campaign-grind]');
    if (grind) grind.textContent = state.label || '2 lb bag';
  }

  function preserveVariantLinks() {
    if (!root.document || !root.location) return;
    Array.prototype.slice.call(root.document.querySelectorAll('variant-picker a[href], [data-option-selector] a[href]')).forEach(function (link) {
      var nextHref = preserveCampaignParams(link.getAttribute('href'), root.location.search);
      link.setAttribute('href', nextHref);
    });
  }

  function bindFormGuard(formId) {
    if (!root.document) return;
    var form = root.document.getElementById(formId);
    if (!form || form.dataset.hwcCampaignFormGuard === 'true') return;
    form.dataset.hwcCampaignFormGuard = 'true';
    form.addEventListener('submit', function () { clearSellingPlan(formId); }, { capture: true });
    form.addEventListener('formdata', function (event) {
      event.formData.delete('selling_plan');
    });
  }

  function applyCampaignMode() {
    if (!root.document || !root.location) return getCampaignState(root.location || {});
    var state = getCampaignState(root.location);
    if (!state.valid) return state;

    root.document.documentElement.setAttribute('data-hwc-campaign-pdp', 'active');
    root.document.documentElement.setAttribute('data-hwc-campaign-variant', state.variantId);
    Array.prototype.slice.call(root.document.querySelectorAll('[data-hwc-campaign-root]')).forEach(function (node) {
      node.setAttribute('data-hwc-purchase-mode', 'onetime');
    });

    var rootNode = root.document.querySelector('[data-hwc-campaign-root]') || root.document;
    var formId = rootNode.getAttribute('data-hwc-product-form-id') || root.document.querySelector('form[action*="/cart/add"]')?.id || '';
    clickOneTimeOption(rootNode);
    clearSellingPlan(formId);
    setCampaignDisplayPrice();
    setButtonText(formId, 'Add 2 lb bag — $45');
    updateCampaignCopy(state);
    preserveVariantLinks();
    bindFormGuard(formId);
    return state;
  }

  function init() {
    var run = function () { applyCampaignMode(); };
    if (!root.document) return;
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
    root.addEventListener && root.addEventListener('load', run, { once: true });
    root.setTimeout && root.setTimeout(run, 500);
    root.setTimeout && root.setTimeout(run, 1500);
    root.setTimeout && root.setTimeout(run, 3000);
    if (root.MutationObserver) {
      var target = root.document.querySelector('[data-hwc-campaign-root]') || root.document.documentElement;
      var queued = false;
      new root.MutationObserver(function () {
        if (queued) return;
        queued = true;
        root.requestAnimationFrame(function () {
          queued = false;
          run();
        });
      }).observe(target, { childList: true, subtree: true });
    }
    root.document.addEventListener('shopify:section:load', run);
  }

  return {
    CONFIG: CONFIG,
    getCampaignState: getCampaignState,
    preserveCampaignParams: preserveCampaignParams,
    isValidCampaignMode: isValidCampaignMode,
    clickOneTimeOption: clickOneTimeOption,
    setCampaignDisplayPrice: setCampaignDisplayPrice,
    applyCampaignMode: applyCampaignMode,
    init: init
  };
});

if (typeof window !== 'undefined' && window.document) {
  window.HWCCampaignPDP.init();
}
